import email from './email';

export const services = { email };
